import { styled } from '@cp/ds/src/theme';
import { Box, BoxProps } from '@cp/ds/src/components/box';
import { ComponentType } from 'react';
import { Tokens, name } from './const';

const FooterBox = styled(Box, { name, slot: 'Footer' })(({ theme }) => ({
  color: Tokens.textColor(),
  paddingTop: theme.spacing(1),
  display: 'flex',
  flexFlow: 'row nowrap',
  justifyContent: 'space-between',
  alignItems: 'center',
  gap: theme.spacing(1),
  '&:empty': {
    display: 'none',
  },
})) as unknown as ComponentType<BoxProps>;

export const Footer = FooterBox;
